import React from 'react';
import RSVP from '../components/RSVP/RSVP';

const RSVPPage: React.FC = () => {
  return (
    <main className="page">
      <RSVP />
    </main>
  );
};

export default RSVPPage; 